<div #overlay class="overlay">
    <div class="content">
        <div class="column-flex">
            <div class="center-content">
                <div class="title">
                    {{
                        isDuplicate
                            ? ('exhaust-setting.duplicate.title' | translate)
                            : ('exhaust-setting.edit-title.title' | translate)
                    }}
                </div>

                <div class="body-wrapper">
                    <app-channel-text-input
                        class="input-container"
                        [value]="title"
                        label="exhaust-setting.edit-title.legent"
                        [name]="'name'"
                        (onInputChange)="title = $event.value"
                        (onFocusChange)="title = $event.value"
                        [maxLength]="40"
                        [inputValidation]="titleValidation"></app-channel-text-input>
                </div>
            </div>

            <div class="buttons-container">
                <div class="button" (click)="closeDialog()">
                    {{ 'exhaust-setting.edit-title.cancel' | translate }}
                </div>
                <div class="button update" (click)="updateTitle()" [ngClass]="{ button_disabled: isCreateDisabled() }">
                    {{ 'exhaust-setting.edit-title.update' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
